//libs
import React, { Component } from 'react';
import {connect} from 'react-redux';
import 'moment/locale/sv';
import 'react-datepicker/dist/react-datepicker.css';
import Alert from 'react-s-alert'
//components
import ShiftTable from './ShiftTable'
import WheelsInTrunkTable from './WheelsInTrunkTable'
import CustomAlert from '../CustomAlert'
import Config from '../../config'
import PageWithSidebar from '../Layouts/PageWithSidebar';

class Stock extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      orders: [],
    }

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit() {
    Alert.info(<CustomAlert />, {
      timeout: 'none'
    })
  }

  render() {
    return (
        <PageWithSidebar page={"orders stock"} location={this.props.location}>

          <h1>Lager</h1>
          {
            Config.api.getRole() === 'ReturnStation' ?
              <WheelsInTrunkTable />
              : (
                <div>
                  <ShiftTable
                    title='Att skifta'
                    type='toShift'
                    name='sendToStation'
                    noRestriction={true}
                    togglePopup={this.togglePopup}
                    wheelStatus = {2}
                  />
                  <ShiftTable
                    title='Skiftade som ska skickas till Centrallager 1'
                    type='toSend'
                    name='sendToCentral'
                    togglePopup={this.togglePopup}
                    wheelStatus = {6}
                  />
                </div>
              )
          }

        </PageWithSidebar>

    );
  }
}

/**
 * Map actions to properties
 */
const mapDispatchToProps = (dispatch) => {
    return {
        Stock: () => dispatch(Stock())
    };
};

/**
 * Export Edit Employee
 */
export default connect(null, mapDispatchToProps)(
  Stock
);



// WEBPACK FOOTER //
// ./src/components/Stock/index.js